import type { CatalogDestination } from '../../core/catalog';

/** Pricing is not permission: preview restrictions and usage limits remain explicit. */
const ACCESS_LABELS: Partial<Record<CatalogDestination, string>> = {
  jobs: 'Free · Sign-in required',
  objectives: 'Free · Sign in for your own material · Usage limits apply',
  rubric: 'Free · Sign-in required · Usage limits apply',
  sites: 'Free allowance · Sign-in required · Usage limits apply',
  writingFeedback: 'Free · Sign-in required · Limited preview',
  collab: 'Free · Sign-in required · Staff only',
  planner: 'Free · Sign-in required · Draft limits apply',
  profile: 'Free · Sign-in required · Staff only',
  aiDetector: 'Free · Sign-in required · Staff only',
  oneStepAhead: 'Free · Sign-in required · Usage limits apply',
};

export default function ToolAccessLabel({ destination }: { destination: CatalogDestination }) {
  const label = ACCESS_LABELS[destination];
  return label ? <p className="preview-access-label">{label}</p> : null;
}
